import React from "react";
import PropTypes from "prop-types";
import {
  TableCell,
  TableRow,
  Box,
  TableContainer,
  Table,
  TableBody,
} from "@material-ui/core/";
import Typography from "@mui/material/Typography";

import classes from "./ProposalMetadata.module.css";
import OverflowWithTipTableRow from "./OverflowWithTipTableRow";

const ProposalMetadata = ({ row, shadow }) => {
  const rowData = [
    { header: "Proposal", value: row.title },
    { header: "Proposal ID", value: row.id },
    { header: "Proposal Lay Description", value: row.lay_description },
    {
      header: "Proposal PI",
      value: `${row.pi.first_name} ${row.pi.last_name}`,
    },
  ];

  const lastRowUI = (title, value) => {
    return (
      <Typography
        style={{
          fontFamily: "Merriweather",
          fontSize: 22,
        }}
        data-testid={`${title.toLowerCase().replace(/ /g, "-")}`}
      >
        <span style={{ fontWeight: "bold" }}>{title}:</span>
        <span style={{ paddingLeft: 10 }}>{value}</span>
      </Typography>
    );
  };

  return (
    <Box elevation={0}>
      <TableContainer
        className={shadow ? classes.shadow : ""}
        style={{ padding: 16 }}
      >
        <Table size="medium" stickyHeader>
          <TableBody style={{ paddingTop: 12 }}>
            {rowData.map(
              (d) =>
                d.value && (
                  <OverflowWithTipTableRow
                    key={`header-${d.header.replace(/ /g, "_")}`}
                    header={d.header}
                    value={`${d.value}`}
                  />
                )
            )}
          </TableBody>
        </Table>
        <Table>
          <TableBody>
            <TableRow className={classes.headerRow}>
              <TableCell>
                <table
                  style={{ width: "auto", position: "relative", left: -4 }}
                >
                  <tbody>
                    <tr>
                      <td>{lastRowUI("Program Year", row.year)}</td>
                      <td style={{ paddingLeft: 24 }}>
                        {lastRowUI("Date Approved", row.date_approved)}
                      </td>
                      <td style={{ paddingLeft: 24 }}>
                        {lastRowUI("Award DOI", row.award_doi)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default ProposalMetadata;

ProposalMetadata.defaultProps = {
  shadow: true,
};

ProposalMetadata.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    total_file_count: PropTypes.number,
    total_file_size: PropTypes.number,
    title: PropTypes.string,
    lay_description: PropTypes.string,
    date_approved: PropTypes.string,
    pi: PropTypes.shape(),
    award_doi: PropTypes.string,
    year: PropTypes.number,
  }).isRequired,
  shadow: PropTypes.bool,
};
